import { useMutation } from '@tanstack/react-query';
import {
  IPatchMyOwnTractorImagesParams,
  patchMyOwnTractorImages,
} from '../../../../api/user/mutations/patchMyOwnTractorImages';

export const usePatchMyOwnTractorImages = () => {
  return useMutation(patchMyOwnTractorImages);
};
